function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#278AFF",
  fillRule: "evenodd",
  d: "M8.535 14.245l-3.62 1.902c-.488.257-1.093.07-1.35-.42-.102-.194-.138-.417-.1-.634l.69-4.03c.056-.324-.051-.655-.287-.885L.94 7.324C.545 6.94.537 6.306.922 5.91c.154-.157.355-.26.573-.292l4.046-.587c.326-.048.607-.252.753-.548L8.104.817c.244-.495.843-.699 1.339-.454.197.097.356.257.454.454l1.81 3.666c.145.296.426.5.752.548l4.046.587c.547.08.926.587.846 1.134-.031.218-.134.419-.291.572l-2.928 2.854c-.236.23-.343.56-.288.885l.691 4.03c.094.544-.272 1.061-.816 1.155-.217.037-.44.002-.635-.1l-3.619-1.903c-.291-.154-.639-.154-.93 0z"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.047f3072.svg";
export { ForwardRef as ReactComponent };